import React from 'react';
import { Row, Col } from 'antd';
import {
  FacebookOutlined,
  TwitterOutlined,
  InstagramOutlined,
  YoutubeOutlined
} from '@ant-design/icons';
import {
  StyledFooter,
  FooterTitle,
  FooterLink,
  FooterText,
  SocialIconsContainer,
  SocialIcon,
  Copyright
} from './Footer.styles';

const Footer = () => {
  return (
    <StyledFooter>
      <div className="container">
        <Row gutter={[24, 32]}>
          <Col xs={24} sm={12} md={6}>
            <FooterTitle>Công ty</FooterTitle>
            <FooterLink href="/about">Giới thiệu</FooterLink>
            <FooterLink href="/team">Đội ngũ</FooterLink>
            <FooterLink href="/careers">Cơ hội nghề nghiệp</FooterLink>
            <FooterLink href="/contact">Liên hệ</FooterLink>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <FooterTitle>Dịch vụ</FooterTitle>
            <FooterLink href="/membership">Thành viên</FooterLink>
            <FooterLink href="/trainers">Huấn luyện viên cá nhân</FooterLink>
            <FooterLink href="/nutrition">Kế hoạch dinh dưỡng</FooterLink>
            <FooterLink href="/classes">Lớp học nhóm</FooterLink>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <FooterTitle>Tài nguyên</FooterTitle>
            <FooterLink href="/blog">Blog</FooterLink>
            <FooterLink href="/faq">Câu hỏi thường gặp</FooterLink>
            <FooterLink href="/privacy">Chính sách bảo mật</FooterLink>
            <FooterLink href="/terms">Điều khoản dịch vụ</FooterLink>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <FooterTitle>Liên hệ</FooterTitle>
            <FooterText>Khu đô thị K, Đại học FPT Đà Nẵng</FooterText>
            <FooterText>info@mixifitness.com</FooterText>
            <FooterText>+84 123 456 789</FooterText>

            <SocialIconsContainer>
              <SocialIcon href="https://facebook.com" target="_blank">
                <FacebookOutlined />
              </SocialIcon>
              <SocialIcon href="https://twitter.com" target="_blank">
                <TwitterOutlined />
              </SocialIcon>
              <SocialIcon href="https://instagram.com" target="_blank">
                <InstagramOutlined />
              </SocialIcon>
              <SocialIcon href="https://youtube.com" target="_blank">
                <YoutubeOutlined />
              </SocialIcon>
            </SocialIconsContainer>
          </Col>
        </Row>

        <Copyright>
          &copy; {new Date().getFullYear()} MIXI Fitness. All rights reserved.
        </Copyright>
      </div>
    </StyledFooter>
  );
};

export default Footer; 